import { createApp } from 'vue'
import App from './App.vue'
import './assets/gymTheme.css'

createApp(App).mount('#app')
